import React from "react"
import {Stack, Typography, useTheme} from "@mui/joy";
import {BellDot} from "lucide-react";
import {useTranslation} from "react-i18next";

const EmptyNotificationComponent = () => {
    const {t} = useTranslation()
    const theme = useTheme()
    return <Stack width={"100%"} paddingY={2} alignItems={"center"} gap={1}>
        <BellDot style={{fontSize: 130, color: theme.palette.text.primary}}/>
        <Typography level={"h4"} fontWeight={"normal"}>
            {t("emptyNotificationsText")}
        </Typography>
    </Stack>
}

export default EmptyNotificationComponent